import { Link } from 'react-router-dom';

export default function Footer() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5c0mvmfmrgp9cvlv8ig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('Iscrizione completata! Riceverai presto i nostri aggiornamenti.');
        form.reset();
      } else {
        alert('Si è verificato un errore. Riprova più tardi.');
      }
    } catch (error) {
      alert('Si è verificato un errore. Riprova più tardi.');
    }
  };

  return (
    <footer className="bg-white py-12 px-6">
      <div className="max-w-7xl mx-auto bg-black rounded-3xl p-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-5">
            <h3 className="text-4xl font-thin text-white mb-4">Resta Aggiornato</h3>
            <p className="text-gray-400 leading-relaxed mb-8">
              Ricevi nuovi contenuti didattici, schede e risorse direttamente nella tua casella email.
            </p>
            <form className="space-y-4" onSubmit={handleSubmit} data-readdy-form>
              <input 
                type="email" 
                name="email"
                placeholder="Inserisci la tua email" 
                className="w-full bg-transparent border-b border-white/30 text-white placeholder-gray-500 py-3 focus:outline-none focus:border-white transition-colors"
                required
                maxLength={100}
              />
              <button type="submit" className="bg-white text-black px-8 py-3 rounded-full hover:bg-gray-200 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
                Iscriviti Ora
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
          
          <div className="md:col-span-3">
            <p className="text-gray-500 text-sm mb-4">Esplora</p>
            <nav className="space-y-4">
              <Link to="/introduzione" className="block text-white hover:text-gray-300 transition-colors cursor-pointer">Introduzione</Link>
              <Link to="/personaggi" className="block text-white hover:text-gray-300 transition-colors cursor-pointer">Personaggi</Link>
              <Link to="/timeline" className="block text-white hover:text-gray-300 transition-colors cursor-pointer">Timeline</Link>
              <Link to="/risorse" className="block text-white hover:text-gray-300 transition-colors cursor-pointer">Risorse</Link>
            </nav>
          </div>
          
          <div className="md:col-span-4">
            <div className="mb-8">
              <p className="text-gray-500 text-sm mb-2">Contatti</p>
              <p className="text-white mb-2">+39 02 1234 5678</p>
              <p className="text-white">info@iliadedidattica.it</p>
            </div>
            <div>
              <p className="text-gray-500 text-sm mb-2">Sede Progetto</p>
              <p className="text-white leading-relaxed">
                Dipartimento di Lettere Classiche<br />
                Università degli Studi - Via Roma 123
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex gap-6">
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">Facebook</a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">Instagram</a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">YouTube</a>
          </div>
          
          <p className="text-white text-center">© 2025 Progetto Iliade Didattica - Tutti i diritti riservati</p>
          
          <div className="flex gap-6">
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">Termini d'Uso</a>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-400 transition-colors text-sm cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
